import { render } from "./couponsManage.vue?vue&type=template&id=dd8ee848&scoped=true"
const script = {}

import "./couponsManage.vue?vue&type=style&index=0&id=dd8ee848&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8ee848"]])

export default __exports__